import React, { useState, useEffect } from "react";
import axios from "axios";
import { navigate } from "gatsby";
import { ArrowLeftIcon } from "../Icons";
import PrimaryButton from "../Button/PrimaryButton";
import {
  Form,
  FormTitle,
  FormRow,
  FormCol,
  FormTwoCol,
  FormAction,
} from "../Form";
import StateSelect from "../StateSelect";

const JoinForm = ({ location = "", thanksURL }) => {
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    zipcode: "",
    message: "",
  });
  const validateEmail = (val) => {
    if (!val) return "Email is required";
    const regex = /^(?!\s)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return regex.test(val)
      ? ""
      : "Input valid email. e.g, name@example.com";
  };

  const validateZip = (val) => {
    if (!val) return "ZIP code is required";
    return /^\d{5}$/.test(val)
      ? ""
      : "It must be exactly five digits.";
  };
  const validateMessage = (val) => {
    if (!val) return "Message is required";
    return val.trimStart().length >= 10
      ? ""
      : "Message must be at least 10 characters long.";
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search)
      if (
        searchParams.get("utm_source") !== "" &&
        searchParams.get("utm_source") !== null
      ) {
        sessionStorage.setItem("utm_source", searchParams.get("utm_source"))
        sessionStorage.setItem("utm_medium", searchParams.get("utm_medium"))
        sessionStorage.setItem("utm_campaign", searchParams.get("utm_campaign"))
        sessionStorage.setItem("utm_term", searchParams.get("utm_term"))
        sessionStorage.setItem("utm_content", searchParams.get("utm_content"))
      }
    }
  }, []);
  const handleSubmit = (e) => {

    const nextErrors = {
      email: validateEmail(email),
      zipcode: validateZip(zipcode),
      message: validateMessage(message),
    };
    setErrors(nextErrors);
    const hasErrors = Object.values(nextErrors).some((m) => m);
    if (hasErrors) {
      return;
    }
    let utm_source_val = "Website"
    let utm_medium_val = ""
    let utm_campaign_val = ""
    let utm_term_val = ""
    let utm_content_val = ""
    if (
      sessionStorage.getItem("utm_source") !== "" &&
      sessionStorage.getItem("utm_source") !== null
    ) {
      utm_source_val = sessionStorage.getItem("utm_source")
      utm_medium_val = sessionStorage.getItem("utm_medium")
      utm_campaign_val = sessionStorage.getItem("utm_campaign")
      utm_term_val = sessionStorage.getItem("utm_term")
      utm_content_val = sessionStorage.getItem("utm_content")
    }
    e.preventDefault();
    if (
      firstname !== "" &&
      lastname !== "" &&
      phone !== "" &&
      email !== "" &&
      zipcode !== "" &&
      message !== ""
    ) {
      let formName = "get-quote-form";
      if (location.pathname === "/rent-to-own-metal-buildings/") {
        formName = "rto-quote-form";
      } else if (location.pathname === "/financing/") {
        formName = "financing-quote-form";
      } else if (location.pathname === "/contact-us/") {
        formName = "contact-us-form";
      } else {
        formName = "get-quote-form";

        if (thanksURL === "/thank-you-get-in-touch/") {
          formName = "get-in-touch-form";
        }
        if (thanksURL === "/thank-you-product-quote/") {
          formName = "product-quote-form";
        }
      }
      const data = {
        source: location.origin,
        form: formName,
        page: location.pathname,
        first_name: firstname,
        last_name: lastname,
        phone_no: phone,
        email: email,
        zipcode: zipcode,
        comment: message,
        utm_medium: utm_medium_val,
        utm_term: utm_term_val,
        utm_campaign: utm_campaign_val,
        utm_content: utm_content_val,
        lead_source: utm_source_val,
      };
      //console.log(data);

      axios({
        method: "post",
        url: "https://crm.senseicrm.com/api/v1/create-lead",
        data: data,
        headers: { Authorization: "Bearer " + process.env.GATSBY_API_TOKEN },
      })
        .then((res) => {
          //console.log("dataLayer start")
          if (typeof dataLayer !== 'undefined') {
            window.dataLayer.push({
              'event': 'form_submit',
              'formName': 'website_forms',
              'enhanced_conversion_data': {
                'email': email,
                'phone_number': phone,
                'zip_code': zipcode
              }
            });
          }
          //console.log("dataLayer end")
          navigate(thanksURL);
          if (typeof window !== `undefined`) {
            document.body.classList.remove("modal-open");
          }
        })
        .catch((error) => {
          alert(error);
        });
    }
  };
  return (
    <>
      <FormTitle className="form-title">Get In Touch With Us</FormTitle>
      <form onSubmit={handleSubmit}>
        <Form className="form">
          <FormRow className="form-row">
            <FormTwoCol className="form-coltwo">
              <div className="form-group">
                <input
                  type="text"
                  id="firstname"
                  className="form-control"
                  placeholder="First Name"
                  pattern="^(?!\s*$)[A-Za-z\s]+$"
                  required
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
            </FormTwoCol>
            <FormTwoCol className="form-coltwo">
              <div className="form-group">
                <input
                  type="text"
                  id="lastname"
                  className="form-control"
                  placeholder="Last Name"
                  pattern="^(?!\s*$)[A-Za-z\s]+$"
                  required
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </FormTwoCol>

            <FormTwoCol className="form-coltwo">
              <div className="form-group  tw-relative">
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="Email"
                  required
                  pattern="^(?!\s)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$"
                  title="Enter a valid email like name@example.com"
                  value={email}
                  onKeyDown={(e) => {
                    // prevent spaces while typing
                    if (e.key === " ") e.preventDefault();
                  }}
                  onPaste={(e) => {
                    // clean pasted text (remove spaces)
                    e.preventDefault();
                    const text = (e.clipboardData || window.clipboardData).getData("text");
                    const cleaned = text.replace(/\s+/g, "");
                    setEmail(cleaned);
                    setErrors((prev) => ({ ...prev, email: validateEmail(cleaned) }));
                  }}
                  onChange={(e) => {
                    // clean typed text (remove spaces)
                    const next = e.target.value;
                    const cleaned = next.replace(/\s+/g, "");
                    setEmail(cleaned);
                    setErrors((prev) => ({ ...prev, email: validateEmail(cleaned) }));
                  }}
                />
                {errors.email && (
                  <div className="error-label tw-absolute tw-z-10">{errors.email}</div>
                )}
              </div>
            </FormTwoCol>
            <FormTwoCol className="form-coltwo">
              <div className="form-group">
                <input
                  type="tel"
                  id="phone_no"
                  className="form-control"
                  placeholder="Phone Number"
                  required
                  pattern="[0-9]{10}"
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </FormTwoCol>
            <FormTwoCol className="form-coltwo">
              <div className="form-group  tw-relative">
                <input
                  type="text"
                  id="zip_code"
                  className="form-control"
                  placeholder="Zip Code"
                  required
                  title="Enter a valid Zip code. It must be exactly five digits"
                  maxLength={5} // blocks extra digits
                  pattern="^\d{5}$" // must be exactly 5 digits
                  onChange={(e) => {
                    // remove non-digits and leading spaces
                    let value = e.target.value.replace(/\D/g, "");
                    if (value.length > 5) {
                      value = value.slice(0, 5);
                    }
                    setZipcode(value);
                    setErrors((prev) => ({ ...prev, zipcode: validateZip(value) }));
                  }}
                  value={zipcode}
                />
                {errors.zipcode && (
                  <div className="error-label  tw-absolute tw-z-10">{errors.zipcode}</div>
                )}
              </div>
            </FormTwoCol>
            <FormTwoCol className="form-coltwo">
              <div className="form-group form-group-select">
                <StateSelect id="state" />
              </div>
            </FormTwoCol>
            <FormCol>
              <div className="form-group tw-relative">
                <textarea
                  name="review"
                  rows="3"
                  id="message"
                  className="form-control"
                  placeholder="Enter Your Message"
                  required
                  minLength={10} // at least 10 characters
                  value={message}
                  onChange={(e) => {
                    let value = e.target.value;

                    // Prevent starting with a space
                    if (value.startsWith(" ")) {
                      value = value.trimStart();
                    }

                    setMessage(value);
                    setErrors((prev) => ({ ...prev, message: validateMessage(value) }));
                  }}
                ></textarea>
                {errors.message && (
                  <div className="error-label tw-absolute tw-z-10">{errors.message}</div>
                )}
              </div>
            </FormCol>
          </FormRow>
          <FormAction className="form-action">
            <button type="submit" aria-label="button">
              <PrimaryButton text="Submit" iconAfter={<ArrowLeftIcon />} />
            </button>
          </FormAction>
        </Form>
      </form>
    </>
  );
};

export default JoinForm;
